export const DASHBOARD_COURIER_ACTION="DASHBOARD_COURIER_ACTION"